import { DataSyncRunSchema } from '../../shared/data-sync';
import { StartExcelDataSyncRequestSchema } from './start-excel-data-sync.schema';
export const startExcelDataSyncContract = {
    method: 'POST',
    path: '/api/v2/data-sync/runs/excel',
    description: 'Start a sync run from the sheets of an uploaded Excel workbook',
    requestSchema: StartExcelDataSyncRequestSchema,
    responseSchema: DataSyncRunSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Bad Request - the upload has no people, or rows with invalid ids, shared names or emails, or references that resolve to no row',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not allowed to manage the data source',
            409: 'Conflict - a sync run is already running'
        }
    }
};

//# sourceMappingURL=start-excel-data-sync.contract.js.map